import React from 'react';

const HeaderDivider = () => (
  <div className="header-divider" />
);

export default HeaderDivider;
